(() => {
  if (window.RoyalInstantPageReady) return;
  window.RoyalInstantPageReady = true;
  // Shopify previews must avoid caching pages rendered from the published theme.
  if (window.Shopify?.designMode) return;
  const previewTheme=window.Shopify?.theme?.role!=='main'&&window.Shopify?.theme?.role!=='live'?window.Shopify?.theme?.id:null;
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const testLink = document.createElement('link');
  if (!testLink.relList?.supports('prefetch')) return;
  const seen = new Set();
  let pending = 0;
  let hoverTimer;
  let lastInput = 0;
  let prepared = 0;
  const failed = new Map();
  const visible = new Set();
  const selector = 'a[href*="/products/"],a[href*="/collections/"]';

  function destination(target) {
    const anchor = target instanceof Element ? target.closest('a[href]') : null;
    if (!anchor || anchor.matches('[data-rh-catalog],[data-rh-open-search],[data-royal-search-trigger],[data-drawer-options],.bee-pr-item-btn,.royal-rating') || anchor.hasAttribute('data-no-instant') || anchor.hasAttribute('download') || anchor.target === '_blank') return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return;
    const current = new URL(location.href);
    const key = value => {
      const copy = new URL(value);
      for (const name of ['pb','preview_theme_id','pr_prod_strat','pr_rec_id','pr_rec_pid','pr_ref_pid','pr_seq']) copy.searchParams.delete(name);
      copy.searchParams.sort(); copy.hash = ''; return copy.href;
    };
    if (key(url) === key(current)) return;
    const path = url.pathname.replace(/^\/(?:az|ru|en)(?=\/|$)/, '') || '/';
    if (!/^(?:\/$|\/(?:products|collections|pages|blogs|policies)(?:\/|$))/.test(path)) return;
    // Shopify variant/recommendation URLs are navigations too, not popup requests.
    const allowed = /^(preview_theme_id|variant|pr_prod_strat|pr_rec_id|pr_rec_pid|pr_ref_pid|pr_seq|pb)$/;
    if ([...url.searchParams.keys()].some(key => !allowed.test(key))) return;
    if(previewTheme)url.searchParams.set('preview_theme_id',String(previewTheme));
    url.hash = '';
    return url.href;
  }

  function prefetch(url, intent = false) {
    if (!url || pending >= 2 || seen.has(url) || (!intent && (prepared >= 16 || failed.has(url))) || (failed.get(url) || 0) >= 2) return;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.fetchPriority = 'low';
    seen.add(url);
    prepared++;
    pending++;
    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      pending--;
      scheduleVisible();
    };
    // No timer releases a slot: an unfinished request stays counted.
    link.addEventListener('load', done, { once: true });
    link.addEventListener('error', () => { seen.delete(url); failed.set(url,(failed.get(url)||0)+1); done(); link.remove(); }, { once: true });
    document.head.appendChild(link);
    return true;
  }

  // Rebuild from the current viewport: offscreen links never wait in a stale queue.
  let visibleTimer;
  let loaded = false;
  const prepareVisible = () => {
    if (!loaded || document.visibilityState === 'hidden' || connection?.saveData || /^(slow-2g|2g|3g)$/.test(connection?.effectiveType || '')) return;
    // Visible high-priority images win over speculative next-page HTML.
    for (const img of document.querySelectorAll('img[fetchpriority="high"],img[loading="eager"]')) {
      if (img.complete) continue;
      const rect = img.getBoundingClientRect();
      if (rect.width && rect.height && rect.top < innerHeight && rect.bottom > 0 && rect.left < innerWidth && rect.right > 0) return;
    }
    for (const anchor of visibilityObserver ? visible : document.querySelectorAll(selector)) {
      if (!anchor.isConnected && anchor.isConnected !== undefined) { visible.delete(anchor); continue; }
      const url = destination(anchor);
      if (!url || seen.has(url) || failed.has(url)) continue;
      if (pending >= 2) break;
      if (anchor.checkVisibility && !anchor.checkVisibility({checkVisibilityCSS:true,checkOpacity:true})) continue;
      const rect = anchor.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= innerHeight || rect.right <= 0 || rect.left >= innerWidth || !anchor.getClientRects().length) continue;
      // A clipped submenu or a link covered by a dialog is not actually visible.
      if (document.elementFromPoint) {
        const x = (Math.max(0, rect.left) + Math.min(innerWidth, rect.right)) / 2;
        const y = (Math.max(0, rect.top) + Math.min(innerHeight, rect.bottom)) / 2;
        const hit = document.elementFromPoint(x, y);
        if (!hit || !(hit === anchor || anchor.contains(hit))) continue;
      }
      prefetch(url);
    }
  };
  function scheduleVisible() {
    if (!loaded) return;
    clearTimeout(visibleTimer);
    visibleTimer = setTimeout(prepareVisible, Math.max(160, 350 - (Date.now() - lastInput)));
  }
  const startVisible = () => {
    const start = () => { loaded = true; scheduleVisible(); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, {timeout:1500});
    else setTimeout(start, 300);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startVisible, {once:true});
  else startVisible();
  addEventListener('scroll', scheduleVisible, {passive:true, capture:true});
  addEventListener('resize', scheduleVisible, {passive:true});
  document.addEventListener('visibilitychange', scheduleVisible);
  document.addEventListener('input', () => { lastInput = Date.now(); scheduleVisible(); }, {passive:true});
  document.addEventListener('load', event => { if (event.target.tagName === 'IMG') scheduleVisible(); }, true);
  document.addEventListener('error', event => { if (event.target.tagName === 'IMG') scheduleVisible(); }, true);
  document.addEventListener('toggle', scheduleVisible, true);
  document.addEventListener('transitionend', scheduleVisible, true);
  document.addEventListener('animationend', scheduleVisible, true);
  const visibilityObserver = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
    }
    scheduleVisible();
  }, {rootMargin:'0px',threshold:0});
  function track(root, remove = false) {
    if (!visibilityObserver || root.nodeType !== 1) return;
    const update = anchor => { if (remove) { visibilityObserver.unobserve(anchor); visible.delete(anchor); } else visibilityObserver.observe(anchor); };
    if (root.matches(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
  }
  if (visibilityObserver) track(document.body);
  // Only new link subtrees are indexed; text/badge updates do not rescan the page.
  if (document.body && typeof MutationObserver !== 'undefined') new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) track(node);
      for (const node of record.removedNodes) track(node, true);
    }
  }).observe(document.body,{childList:true,subtree:true});

  document.addEventListener('mouseover', event => {
    const url = destination(event.target);
    clearTimeout(hoverTimer);
    if (url) hoverTimer = setTimeout(() => prefetch(url, true), 80);
  }, { passive: true });
  document.addEventListener('mouseout', event => {
    if (destination(event.target) !== destination(event.relatedTarget)) clearTimeout(hoverTimer);
  }, { passive: true });
  document.addEventListener('focusin', event => prefetch(destination(event.target), true));
  document.addEventListener('pointerdown', event => {
    if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey) prefetch(destination(event.target), true);
  }, { passive: true });
})();
